import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import JsBarcode from "jsbarcode";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

//--------Material React Table------//
import { Box, Button } from "@mui/material";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { Stack } from "react-bootstrap";
import { handleSaveColumnOrder } from "../../../common/common";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const ProfitandLossDetail = (props) => {
  const token = localStorage.getItem("Token");
  const loginuserid = localStorage.getItem("ID");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [totalCostOfGoodsSold, setTotalCostOfGoodsSold] = useState(0);
  const [totalOtherIncomeExpense, setTotalOtherIncomeExpense] = useState(0);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});

  //table state
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState([]);

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    setLoading(true);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/profitlossdetail?startdate=${startdate}&enddate=${enddate}&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res.data.ResponseData.list);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData.list?.map((el) => ({
            ...el,
            Amount: Number(el?.Amount),
          }));
          setResponseData(FilterData);
          setData(FilterData);

          console.log("11", responseData);
          setColumnOrder(
            res.data.ResponseData?.ColumnOrder?.length > 0
              ? res.data.ResponseData?.ColumnOrder.split(",")
              : ["mrt-row-select", ...columns.map((c) => c.accessorKey)]
          );

          // const keysToSetFalse = res.data.ResponseData?.ColumnsHide.length || "" ;
          const keysToSetFalse =
            res.data.ResponseData?.ColumnsHide.length > 0
              ? res.data.ResponseData?.ColumnsHide
              : ["mrt-row-select", ...columns.map((c) => c.accessorKey)];
          console.log(keysToSetFalse, "keysToSetFalse");
          // Create default object with all values set to true
          const obj = columns.reduce((acc, item) => {
            acc[item.accessorKey] = true;
            return acc;
          }, {});

          // Comma-separated string of keys to set to false

          // Convert the string to an array and set the corresponding keys in the object to false
          keysToSetFalse.split(",").forEach((key) => {
            if (obj.hasOwnProperty(key)) {
              obj[key] = false;
            }
          });

          console.log(obj, "checkobj");

          setColumnVisibility(obj);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    apicall();
  }, [startdate, enddate]);

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, [startdate, enddate]);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const validData = Array.isArray(responseData) ? responseData : []; // Default to empty array if not valid
    const sum = validData.reduce((total, report) => {
      const reportTotal = Number(report?.Total);
  
      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);
  
    setTotalSum(sum);
  };
  

  // to calculate the total
  const calculateTotalIncome = () => {
    if (!Array.isArray(responseData)) {
      // Handle invalid responseData by setting total income to 0 or any fallback
      setTotalIncome(0);
      return;
    }
  
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);
  
      if (
        typeof reportTotal === "number" &&
        !isNaN(reportTotal) &&
        report.AccountTypeId === 1
      ) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);
  
    setTotalIncome(sum);
  };
  

  const calculateTotalCostOfGoodsSold = () => {
    if (!Array.isArray(responseData)) {
      // Handle case where responseData is not an array (could log or set the total to 0)
      setTotalCostOfGoodsSold(0);
      return;
    }
  
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);
  
      if (
        typeof reportTotal === "number" &&
        !isNaN(reportTotal) &&
        report.AccountTypeId === 3
      ) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);
  
    setTotalCostOfGoodsSold(sum);
  };
  
  const calculateTotalExpense = () => {
    if (!Array.isArray(responseData)) {
      // If responseData is not an array, set total expense to 0
      setTotalExpense(0);
      return;
    }
  
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);
  
      if (
        typeof reportTotal === "number" &&
        !isNaN(reportTotal) &&
        report.AccountTypeId === 4
      ) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);
  
    setTotalExpense(sum);
  };
  

  const calculateTotalOtherIncomeExpense = () => {
    if (!Array.isArray(responseData)) {
      // If responseData is not an array, set total to 0
      setTotalOtherIncomeExpense(0);
      return;
    }
  
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);
  
      if (
        typeof reportTotal === "number" &&
        !isNaN(reportTotal) &&
        report.Type === "Other Income/Expense"
      ) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);
  
    setTotalOtherIncomeExpense(sum);
  };
  

  useEffect(() => {
    calculateTotalSum();
    calculateTotalCostOfGoodsSold();
    calculateTotalIncome();
    calculateTotalExpense();
    calculateTotalOtherIncomeExpense();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };


  const columns = [
    {
      header: "Date",
      accessorKey: "Date",
      size: "120",
      Cell: ({ row }) => {
        const TransactionDate = moment(row.original.Date);
        if (TransactionDate.isValid()) {
          return TransactionDate.format("MM/DD/YYYY");
        } else {
          return "";
        }
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      size: "120",
    },
    {
      header: "Num",
      accessorKey: "Num",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Memo/Description",
      accessorKey: "MemoDescription",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      filterFn: "contains",
      size: "120",
      Cell: ({ row }) => parseFloat(row.original.Amount).toFixed(2),
      AggregatedCell: ({ cell, table }) => {
        // Extract the grouped value
        const groupedValue =
          cell.row.subRows?.[0]?.original[cell.row.groupingColumnId];

        return (
          <>
            Total for {groupedValue}:{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {" " +
                cell.getValue()?.toLocaleString?.("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
            </Box>
          </>
        );
      },
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      filterFn: "contains",
      size: "120",
      Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
    },
    {
      header: "Create Date",
      accessorKey: "CreateDate",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) =>
        moment(row.original.CreateDate).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) =>
        moment(row.original.LastModified).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Debit",
      accessorKey: "Debit",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => parseFloat(row.original.Debit).toFixed(2),
    },
    {
      header: "Credit",
      accessorKey: "Credit",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => parseFloat(row.original.Debit).toFixed(2),
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Account Name",
      accessorKey: "AccountName",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Account Type",
      accessorKey: "AccountType",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Type",
      accessorKey: "Type",
      filterFn: "contains",
      size: "120",
      Footer: () => (
        <>
          {/* <div style={{ textAlign: "end" }}> */}
          <Stack>
            Gross Profit: {(totalIncome - totalCostOfGoodsSold).toFixed(2)}
            {/* <Box color="warning.main"></Box> */}
          </Stack>
          <Stack>
            Net Income:{" "}
            {(
              totalIncome +
              totalExpense +
              totalCostOfGoodsSold -
              totalOtherIncomeExpense
            ).toFixed(2)}
            {/* <Box color="warning.main"></Box> */}
          </Stack>
          {/* </div> */}
        </>
      ),
    },
  ];

  const defaultColDef = {
    sortable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  const onGridReady = useCallback((params) => {
    setLoading(true);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/profitlossdetail?startdate=${""}&enddate=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
          // setOpenBalance(res.data.ResponseData.OpenBalance);
        }
        data.Total = parseInt(data.Total, 10);
        data.Balance = parseInt(data.Balance, 10); // Convert to integer

        console.log("data.OpenBalance", data.OpenBalance);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    onGridReady();
  }, [onGridReady]);

  const totalFooterRow = {
    Product: "Net Income",
    Total: totalSum,
    // OpenBalance: totalbalance,
  };

  // const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Profit and Loss Detail
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
              </div>
              <div
              className="cursor-pointer col-md-3 d-flex justify-content-end mt-5"
              onClick={() =>
                handleSaveColumnOrder(
                  loginuserid,
                  "ProfitAndLossReport",
                  columnOrder,
                  token,
                  columnVisibility
                )
              }
              title="Lock Your Sequence"
            >
              <i class="fa fa-lock columnsLock fs-4"></i>
            </div>
            
          </div>

          {/* Receipt */}

          <div className="card mt-3">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Profit and Loss Detail</p>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              <div>
                <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Profit And Loss Report"
                  columns={columns}
                  data={responseData}
                  startdate={startdate}
                  enddate={enddate}
                  columnGrouping={["Type", "AccountType", "AccountName"]}
                  // columnsVisibility={{
                  //   CreateDate: false,
                  //   CreatedBy: false,
                  //   LastModified: false,
                  //   LastModifiedBy: false,
                  //   Debit: false,
                  //   Credit: false,
                  //   PaymentMethod: false,
                  // }}
                  setColumnOrder={setColumnOrder}
                  setColumnVisibility = {setColumnVisibility}
                  state={{
                    columnOrder,
                    columnVisibility,
                  }}
                
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfitandLossDetail;
